import { Container, ContainerProps, Flex, FlexProps, Heading } from '@chakra-ui/react';
import { PropsWithChildren, ReactNode } from 'react';
import { BreadcrumbInfoItems, SimpleBreadcrumb } from '../SimpleBreadcrumb';

export interface PageContentProps extends PropsWithChildren<Omit<FlexProps, 'title'>> {
  title?: ReactNode;
  subtitle?: ReactNode;
  actionsContent?: ReactNode;
  breadcrumbItems?: BreadcrumbInfoItems;
  containerProps?: ContainerProps;
}

export const PageContent = ({
  children,
  title,
  subtitle,
  actionsContent,
  containerProps,
  breadcrumbItems,
  ...props
}: PageContentProps) => {
  return (
    <Flex direction='column' className='page-content' px='0' gap='medium'>
      {breadcrumbItems && <SimpleBreadcrumb items={breadcrumbItems} />}
      <Container
        flexDirection='column'
        display='flex'
        maxWidth='full'
        px={{ base: 'deka', lg: 'large' }}
        gap='xsmall'
        flexGrow={1}
        {...containerProps}
      >
        {Boolean(title || actionsContent) && (
          <Flex direction={{ base: 'column', md: 'row' }} justify='space-between' align={{ md: 'center' }} gap='micro'>
            <Flex direction='column' gap={2}>
              {title && <Heading variant='pageTitle' textTransform="uppercase">{title}</Heading>}
              {subtitle && <Heading variant='pageSubtitle'>{subtitle}</Heading>}
            </Flex>

            {Boolean(actionsContent) && <Flex align='center'>{actionsContent}</Flex>}
          </Flex>
        )}

        <Flex direction='column' flexGrow={1} {...props}>
          {children}
        </Flex>
      </Container>
    </Flex>
  );
};
